/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeCommunityGoalResponse } from './ChallengeCommunityGoalResponse';
import {
    ChallengeCommunityGoalResponseFromJSON,
    ChallengeCommunityGoalResponseFromJSONTyped,
    ChallengeCommunityGoalResponseToJSON,
    ChallengeCommunityGoalResponseToJSONTyped,
} from './ChallengeCommunityGoalResponse';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { ChallengeDraw } from './ChallengeDraw';
import {
    ChallengeDrawFromJSON,
    ChallengeDrawFromJSONTyped,
    ChallengeDrawToJSON,
    ChallengeDrawToJSONTyped,
} from './ChallengeDraw';
import type { ChallengeEmailConfig } from './ChallengeEmailConfig';
import {
    ChallengeEmailConfigFromJSON,
    ChallengeEmailConfigFromJSONTyped,
    ChallengeEmailConfigToJSON,
    ChallengeEmailConfigToJSONTyped,
} from './ChallengeEmailConfig';
import type { ChallengeVideoSection } from './ChallengeVideoSection';
import {
    ChallengeVideoSectionFromJSON,
    ChallengeVideoSectionFromJSONTyped,
    ChallengeVideoSectionToJSON,
    ChallengeVideoSectionToJSONTyped,
} from './ChallengeVideoSection';
import type { ChallengeEligibilityCheckbox } from './ChallengeEligibilityCheckbox';
import {
    ChallengeEligibilityCheckboxFromJSON,
    ChallengeEligibilityCheckboxFromJSONTyped,
    ChallengeEligibilityCheckboxToJSON,
    ChallengeEligibilityCheckboxToJSONTyped,
} from './ChallengeEligibilityCheckbox';
import type { SignupMethod } from './SignupMethod';
import {
    SignupMethodFromJSON,
    SignupMethodFromJSONTyped,
    SignupMethodToJSON,
    SignupMethodToJSONTyped,
} from './SignupMethod';
import type { ChallengeContentSection } from './ChallengeContentSection';
import {
    ChallengeContentSectionFromJSON,
    ChallengeContentSectionFromJSONTyped,
    ChallengeContentSectionToJSON,
    ChallengeContentSectionToJSONTyped,
} from './ChallengeContentSection';
import type { ChallengeOnboarding } from './ChallengeOnboarding';
import {
    ChallengeOnboardingFromJSON,
    ChallengeOnboardingFromJSONTyped,
    ChallengeOnboardingToJSON,
    ChallengeOnboardingToJSONTyped,
} from './ChallengeOnboarding';
import type { ChallengeEligibilityGeo } from './ChallengeEligibilityGeo';
import {
    ChallengeEligibilityGeoFromJSON,
    ChallengeEligibilityGeoFromJSONTyped,
    ChallengeEligibilityGeoToJSON,
    ChallengeEligibilityGeoToJSONTyped,
} from './ChallengeEligibilityGeo';
import type { ChallengePageMode } from './ChallengePageMode';
import {
    ChallengePageModeFromJSON,
    ChallengePageModeFromJSONTyped,
    ChallengePageModeToJSON,
    ChallengePageModeToJSONTyped,
} from './ChallengePageMode';
import type { ChallengeReferralBonus } from './ChallengeReferralBonus';
import {
    ChallengeReferralBonusFromJSON,
    ChallengeReferralBonusFromJSONTyped,
    ChallengeReferralBonusToJSON,
    ChallengeReferralBonusToJSONTyped,
} from './ChallengeReferralBonus';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';
import type { ChallengeFaqDetails } from './ChallengeFaqDetails';
import {
    ChallengeFaqDetailsFromJSON,
    ChallengeFaqDetailsFromJSONTyped,
    ChallengeFaqDetailsToJSON,
    ChallengeFaqDetailsToJSONTyped,
} from './ChallengeFaqDetails';
import type { ChallengeGrandPrize } from './ChallengeGrandPrize';
import {
    ChallengeGrandPrizeFromJSON,
    ChallengeGrandPrizeFromJSONTyped,
    ChallengeGrandPrizeToJSON,
    ChallengeGrandPrizeToJSONTyped,
} from './ChallengeGrandPrize';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { ChallengeInstantReward } from './ChallengeInstantReward';
import {
    ChallengeInstantRewardFromJSON,
    ChallengeInstantRewardFromJSONTyped,
    ChallengeInstantRewardToJSON,
    ChallengeInstantRewardToJSONTyped,
} from './ChallengeInstantReward';
import type { ChallengePromotionsSectionConfig } from './ChallengePromotionsSectionConfig';
import {
    ChallengePromotionsSectionConfigFromJSON,
    ChallengePromotionsSectionConfigFromJSONTyped,
    ChallengePromotionsSectionConfigToJSON,
    ChallengePromotionsSectionConfigToJSONTyped,
} from './ChallengePromotionsSectionConfig';
import type { ChallengeSectionStyleConfig } from './ChallengeSectionStyleConfig';
import {
    ChallengeSectionStyleConfigFromJSON,
    ChallengeSectionStyleConfigFromJSONTyped,
    ChallengeSectionStyleConfigToJSON,
    ChallengeSectionStyleConfigToJSONTyped,
} from './ChallengeSectionStyleConfig';
import type { ChallengeSegment } from './ChallengeSegment';
import {
    ChallengeSegmentFromJSON,
    ChallengeSegmentFromJSONTyped,
    ChallengeSegmentToJSON,
    ChallengeSegmentToJSONTyped,
} from './ChallengeSegment';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { EligibilityConfig } from './EligibilityConfig';
import {
    EligibilityConfigFromJSON,
    EligibilityConfigFromJSONTyped,
    EligibilityConfigToJSON,
    EligibilityConfigToJSONTyped,
} from './EligibilityConfig';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';

/**
 * 
 * @export
 * @interface ChallengeInfoResponse
 */
export interface ChallengeInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    updatedAt: number;
    /**
     * The title of the challenge
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    name: string;
    /**
     * The title of the challenge on the card on DevourPlay Play tab.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    cardTitle?: string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    backgroundImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    backgroundImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandLogo?: string;
    /**
     * Hex color code for the brand
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandColor?: string;
    /**
     * Hex color code for the brand
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    textColor?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    disclaimerTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    disclaimerDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    hasEnded?: boolean;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    isActive?: boolean;
    /**
     * Whether the challenge is only available to admins.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    isAdminOnly?: boolean;
    /**
     * Whether to show this challenge as a promo card on CockpitV3 and other discovery surfaces.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    showPromoCard?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    numberOfEntrants?: number;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    termsUrl?: string;
    /**
     * Rich text (HTML) terms and rules content for display on challenge page
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    termsContent?: string;
    /**
     * 
     * @type {ChallengeOnboarding}
     * @memberof ChallengeInfoResponse
     */
    onboardingSection?: ChallengeOnboarding;
    /**
     * 
     * @type {Array<ChallengeFaqDetails>}
     * @memberof ChallengeInfoResponse
     */
    faqs?: Array<ChallengeFaqDetails>;
    /**
     * Optional per-challenge eligibility checkboxes rendered alongside 18+ and Terms in the sign-in modal. Empty/omitted means no extra checkboxes (matches default behavior).
     * @type {Array<ChallengeEligibilityCheckbox>}
     * @memberof ChallengeInfoResponse
     */
    eligibilityCheckboxes?: Array<ChallengeEligibilityCheckbox>;
    /**
     * 
     * @type {ChallengeEligibilityGeo}
     * @memberof ChallengeInfoResponse
     */
    eligibilityGeo?: ChallengeEligibilityGeo;
    /**
     * 
     * @type {EligibilityConfig}
     * @memberof ChallengeInfoResponse
     */
    eligibilityConfig?: EligibilityConfig;
    /**
     * 
     * @type {Array<ChallengeSegment>}
     * @memberof ChallengeInfoResponse
     */
    segments?: Array<ChallengeSegment>;
    /**
     * Admin-scheduled random drawings, each with own date/time, qualification mode, and reward set. Orthogonal to segments — drawing cadence is independent of scoring windows.
     * @type {Array<ChallengeDraw>}
     * @memberof ChallengeInfoResponse
     */
    draws?: Array<ChallengeDraw>;
    /**
     * 
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    prizePoolFeatureImage?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    titleFontSize?: number;
    /**
     * The slug of the brand map associated with this challenge.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandMapSlug?: string;
    /**
     * CDN URL of the brand logo for header/navbar rendering. Resolves in priority order — the per-challenge `brandLogo` Asset (admin override) first, then the linked `brandId → Brand.logo` Asset. Undefined when neither is set.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandLogoUrl?: string;
    /**
     * CDN URL for large background image asset
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    backgroundImageLargeUrl?: string;
    /**
     * CDN URL for small background image asset
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    backgroundImageSmallUrl?: string;
    /**
     * CDN URL for prize pool feature image asset
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    prizePoolFeatureImageUrl?: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof ChallengeInfoResponse
     */
    challengeType?: ChallengeType;
    /**
     * 
     * @type {ChallengePageMode}
     * @memberof ChallengeInfoResponse
     */
    pageMode?: ChallengePageMode;
    /**
     * URL-friendly identifier for the challenge (e.g., "my-brand-challenge")
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    slug?: string;
    /**
     * External URL for challenge landing page (e.g., "https://my-campaign.gg"). When set, promotional cards open this URL in a new window instead of navigating internally.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    landingPageUrl?: string;
    /**
     * Whether the challenge requires DevourPlay app to be installed
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    requiresDevourPlay?: boolean;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof ChallengeInfoResponse
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof ChallengeInfoResponse
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof ChallengeInfoResponse
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {ChallengeVideoSection}
     * @memberof ChallengeInfoResponse
     */
    videoSection?: ChallengeVideoSection;
    /**
     * Custom HTML content sections
     * @type {Array<ChallengeContentSection>}
     * @memberof ChallengeInfoResponse
     */
    contentSections?: Array<ChallengeContentSection>;
    /**
     * 
     * @type {PageSeo}
     * @memberof ChallengeInfoResponse
     */
    seo?: PageSeo;
    /**
     * Asset ID for default user avatar (shown when user has no profile pic, in leaderboards etc)
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    defaultAvatarImageId?: string;
    /**
     * CDN URL for default avatar image (in response)
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    defaultAvatarImageUrl?: string;
    /**
     * 
     * @type {ChallengeEmailConfig}
     * @memberof ChallengeInfoResponse
     */
    emailConfig?: ChallengeEmailConfig;
    /**
     * Optional https webhook URL for challenge-specific operational alerts. Per-challenge so each brand engagement routes its own support signal to its own destination (Slack incoming webhook, Discord webhook, internal endpoint, etc.) without a backend env var change. Skipped silently when unset (audit log still writes). **Write-only** — the model marks the property `select:false` AND the `ChallengeResponse` interface omits it; the field is structurally absent from every client response and is set via the admin CREATE/UPDATE body only.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    notificationWebhookUrl?: string;
    /**
     * Optional reference to a Brand entity for brand assignment
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandId?: string;
    /**
     * Link to unified BrandActivation record (auto-created, type BRAND_CHALLENGE)
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandActivationId?: string;
    /**
     * Brand name (populated from brandId when available)
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    brandName?: string;
    /**
     * Challenge start timestamp (computed from earliest segment startAt)
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    start?: number;
    /**
     * Challenge end timestamp (computed from latest segment endAt)
     * @type {number}
     * @memberof ChallengeInfoResponse
     */
    end?: number;
    /**
     * 
     * @type {ChallengeGrandPrize}
     * @memberof ChallengeInfoResponse
     */
    grandPrize?: ChallengeGrandPrize;
    /**
     * 
     * @type {ChallengeCommunityGoalResponse}
     * @memberof ChallengeInfoResponse
     */
    communityGoal?: ChallengeCommunityGoalResponse;
    /**
     * 
     * @type {ChallengePromotionsSectionConfig}
     * @memberof ChallengeInfoResponse
     */
    promotionsSection?: ChallengePromotionsSectionConfig;
    /**
     * Custom HTML content for left side of FAQ section
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    faqLeftContent?: string;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeInfoResponse
     */
    faqStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeInfoResponse
     */
    onboardingStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeInfoResponse
     */
    prizeSectionStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeInfoResponse
     */
    entriesColumnStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof ChallengeInfoResponse
     */
    questsStyles?: ChallengeSectionStyleConfig;
    /**
     * Custom HTML injected into the `<head>` of the challenge page.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    customHeadHtml?: string;
    /**
     * Custom HTML injected into the `<body>` of the challenge page.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    customBodyHtml?: string;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof ChallengeInfoResponse
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * Optional GamificationModel ID (e.g. WHEEL_SPIN) wired to this challenge for interactive reward mechanics
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    gamificationModelId?: string;
    /**
     * Optional uppercase prefix prepended to challenge-scoped referral codes (e.g. "RTTR" → RTTR12345). When set, codes generated for this challenge use a 5-digit numeric suffix; when unset, the platform short-uuid format is used.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    referralCodePrefix?: string;
    /**
     * 
     * @type {ChallengeReferralBonus}
     * @memberof ChallengeInfoResponse
     */
    referralBonus?: ChallengeReferralBonus;
    /**
     * Optional whitelist of signup methods exposed on ChallengeLoginModal. Empty/undefined renders all methods (legacy behavior). When set, only providers in this list are shown — e.g. ["EMAIL"] hides social signup entirely.
     * @type {Array<SignupMethod>}
     * @memberof ChallengeInfoResponse
     */
    allowedSignupMethods?: Array<SignupMethod>;
    /**
     * Cumulative-point thresholds (across all of this challenge's activations + segments) at which the user is granted a wheel spin via the gamificationModelId. Idempotent — each threshold awarded at most once per user. Empty/undefined disables milestone-triggered spins; the standard time-window reset on the GamificationModel still applies if configured. The model's stored default is an empty array — no platform-wide thresholds.
     * @type {Array<number>}
     * @memberof ChallengeInfoResponse
     */
    wheelMilestoneThresholds?: Array<number>;
    /**
     * Whether the challenge has been accepted by the user only if the user is logged in.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    isAccepted?: boolean;
    /**
     * For branded challenges with a post-signup onboarding flow (e.g. RTTR avatar/nickname capture), true once the user has been through that flow (Submit OR Skip). Gates the per-login auto-pop of the onboarding modal. Always false when no membership exists yet.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    onboardingComplete?: boolean;
    /**
     * The current user's ChallengeMembership.status. Drives the RTTR leaderboard default tab, view-only Finals mode, and bragging-rights surfaces.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    myStatus?: ChallengeInfoResponseMyStatusEnum | null;
    /**
     * ISO-3166-1 alpha-2 country code captured at registration on the current user's ChallengeMembership. Undefined when unauthenticated or no eligibilityGeo. Used together with myStatus to drive the bragging-rights surfaces.
     * @type {string}
     * @memberof ChallengeInfoResponse
     */
    myDeclaredCountry?: string | null;
    /**
     * True when the authenticated user has a ChallengeMembership but is missing required profile data — either `acceptedTermsAt` (attestation) or `declaredCountry` (geo). Drives the persistent post-login ProfileCompletionModal on the hub. Always false when unauthenticated or no membership exists yet.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    myMembershipNeedsCompletion?: boolean;
    /**
     * True when the current user's ChallengeMembership has a non-zero `acceptedTermsAt`. Frontend pairs this with `myDeclaredCountry` to decide which input groups the ProfileCompletionModal should render. Always false when unauthenticated or no membership exists yet.
     * @type {boolean}
     * @memberof ChallengeInfoResponse
     */
    myAttestationOnFile?: boolean;
    /**
     * 
     * @type {ChallengeInstantReward}
     * @memberof ChallengeInfoResponse
     */
    instantReward?: ChallengeInstantReward;
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof ChallengeInfoResponse
     */
    games?: Array<OWGameResponse>;
}


/**
 * @export
 */
export const ChallengeInfoResponseMyStatusEnum = {
    eligible: 'eligible',
    PrizeRestricted: 'prize-restricted',
    spectator: 'spectator',
    disabled: 'disabled'
} as const;
export type ChallengeInfoResponseMyStatusEnum = typeof ChallengeInfoResponseMyStatusEnum[keyof typeof ChallengeInfoResponseMyStatusEnum];


/**
 * Check if a given object implements the ChallengeInfoResponse interface.
 */
export function instanceOfChallengeInfoResponse(value: object): value is ChallengeInfoResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ChallengeInfoResponseFromJSON(json: any): ChallengeInfoResponse {
    return ChallengeInfoResponseFromJSONTyped(json, false);
}

export function ChallengeInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'cardTitle': json['cardTitle'] == null ? undefined : json['cardTitle'],
        'description': json['description'],
        'backgroundImageLarge': json['backgroundImageLarge'] == null ? undefined : json['backgroundImageLarge'],
        'backgroundImageSmall': json['backgroundImageSmall'] == null ? undefined : json['backgroundImageSmall'],
        'brandLogo': json['brandLogo'] == null ? undefined : json['brandLogo'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'disclaimerTitle': json['disclaimerTitle'] == null ? undefined : json['disclaimerTitle'],
        'disclaimerDescription': json['disclaimerDescription'] == null ? undefined : json['disclaimerDescription'],
        'hasEnded': json['hasEnded'] == null ? undefined : json['hasEnded'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isAdminOnly': json['isAdminOnly'] == null ? undefined : json['isAdminOnly'],
        'showPromoCard': json['showPromoCard'] == null ? undefined : json['showPromoCard'],
        'numberOfEntrants': json['numberOfEntrants'] == null ? undefined : json['numberOfEntrants'],
        'termsUrl': json['termsUrl'] == null ? undefined : json['termsUrl'],
        'termsContent': json['termsContent'] == null ? undefined : json['termsContent'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : ChallengeOnboardingFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(ChallengeFaqDetailsFromJSON)),
        'eligibilityCheckboxes': json['eligibilityCheckboxes'] == null ? undefined : ((json['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxFromJSON)),
        'eligibilityGeo': json['eligibilityGeo'] == null ? undefined : ChallengeEligibilityGeoFromJSON(json['eligibilityGeo']),
        'eligibilityConfig': json['eligibilityConfig'] == null ? undefined : EligibilityConfigFromJSON(json['eligibilityConfig']),
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ChallengeSegmentFromJSON)),
        'draws': json['draws'] == null ? undefined : ((json['draws'] as Array<any>).map(ChallengeDrawFromJSON)),
        'prizePoolFeatureImage': json['prizePoolFeatureImage'] == null ? undefined : json['prizePoolFeatureImage'],
        'titleFontSize': json['titleFontSize'] == null ? undefined : json['titleFontSize'],
        'brandMapSlug': json['brandMapSlug'] == null ? undefined : json['brandMapSlug'],
        'brandLogoUrl': json['brandLogoUrl'] == null ? undefined : json['brandLogoUrl'],
        'backgroundImageLargeUrl': json['backgroundImageLargeUrl'] == null ? undefined : json['backgroundImageLargeUrl'],
        'backgroundImageSmallUrl': json['backgroundImageSmallUrl'] == null ? undefined : json['backgroundImageSmallUrl'],
        'prizePoolFeatureImageUrl': json['prizePoolFeatureImageUrl'] == null ? undefined : json['prizePoolFeatureImageUrl'],
        'challengeType': json['challengeType'] == null ? undefined : ChallengeTypeFromJSON(json['challengeType']),
        'pageMode': json['pageMode'] == null ? undefined : ChallengePageModeFromJSON(json['pageMode']),
        'slug': json['slug'] == null ? undefined : json['slug'],
        'landingPageUrl': json['landingPageUrl'] == null ? undefined : json['landingPageUrl'],
        'requiresDevourPlay': json['requiresDevourPlay'] == null ? undefined : json['requiresDevourPlay'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'videoSection': json['videoSection'] == null ? undefined : ChallengeVideoSectionFromJSON(json['videoSection']),
        'contentSections': json['contentSections'] == null ? undefined : ((json['contentSections'] as Array<any>).map(ChallengeContentSectionFromJSON)),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'defaultAvatarImageId': json['defaultAvatarImageId'] == null ? undefined : json['defaultAvatarImageId'],
        'defaultAvatarImageUrl': json['defaultAvatarImageUrl'] == null ? undefined : json['defaultAvatarImageUrl'],
        'emailConfig': json['emailConfig'] == null ? undefined : ChallengeEmailConfigFromJSON(json['emailConfig']),
        'notificationWebhookUrl': json['notificationWebhookUrl'] == null ? undefined : json['notificationWebhookUrl'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'brandActivationId': json['brandActivationId'] == null ? undefined : json['brandActivationId'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'grandPrize': json['grandPrize'] == null ? undefined : ChallengeGrandPrizeFromJSON(json['grandPrize']),
        'communityGoal': json['communityGoal'] == null ? undefined : ChallengeCommunityGoalResponseFromJSON(json['communityGoal']),
        'promotionsSection': json['promotionsSection'] == null ? undefined : ChallengePromotionsSectionConfigFromJSON(json['promotionsSection']),
        'faqLeftContent': json['faqLeftContent'] == null ? undefined : json['faqLeftContent'],
        'faqStyles': json['faqStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['faqStyles']),
        'onboardingStyles': json['onboardingStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['onboardingStyles']),
        'prizeSectionStyles': json['prizeSectionStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['prizeSectionStyles']),
        'entriesColumnStyles': json['entriesColumnStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['entriesColumnStyles']),
        'questsStyles': json['questsStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['questsStyles']),
        'customHeadHtml': json['customHeadHtml'] == null ? undefined : json['customHeadHtml'],
        'customBodyHtml': json['customBodyHtml'] == null ? undefined : json['customBodyHtml'],
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'gamificationModelId': json['gamificationModelId'] == null ? undefined : json['gamificationModelId'],
        'referralCodePrefix': json['referralCodePrefix'] == null ? undefined : json['referralCodePrefix'],
        'referralBonus': json['referralBonus'] == null ? undefined : ChallengeReferralBonusFromJSON(json['referralBonus']),
        'allowedSignupMethods': json['allowedSignupMethods'] == null ? undefined : ((json['allowedSignupMethods'] as Array<any>).map(SignupMethodFromJSON)),
        'wheelMilestoneThresholds': json['wheelMilestoneThresholds'] == null ? undefined : json['wheelMilestoneThresholds'],
        'isAccepted': json['isAccepted'] == null ? undefined : json['isAccepted'],
        'onboardingComplete': json['onboardingComplete'] == null ? undefined : json['onboardingComplete'],
        'myStatus': json['myStatus'] == null ? undefined : json['myStatus'],
        'myDeclaredCountry': json['myDeclaredCountry'] == null ? undefined : json['myDeclaredCountry'],
        'myMembershipNeedsCompletion': json['myMembershipNeedsCompletion'] == null ? undefined : json['myMembershipNeedsCompletion'],
        'myAttestationOnFile': json['myAttestationOnFile'] == null ? undefined : json['myAttestationOnFile'],
        'instantReward': json['instantReward'] == null ? undefined : ChallengeInstantRewardFromJSON(json['instantReward']),
        'games': json['games'] == null ? undefined : ((json['games'] as Array<any>).map(OWGameResponseFromJSON)),
    };
}

export function ChallengeInfoResponseToJSON(json: any): ChallengeInfoResponse {
    return ChallengeInfoResponseToJSONTyped(json, false);
}

export function ChallengeInfoResponseToJSONTyped(value?: ChallengeInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'cardTitle': value['cardTitle'],
        'description': value['description'],
        'backgroundImageLarge': value['backgroundImageLarge'],
        'backgroundImageSmall': value['backgroundImageSmall'],
        'brandLogo': value['brandLogo'],
        'brandColor': value['brandColor'],
        'textColor': value['textColor'],
        'disclaimerTitle': value['disclaimerTitle'],
        'disclaimerDescription': value['disclaimerDescription'],
        'hasEnded': value['hasEnded'],
        'isActive': value['isActive'],
        'isAdminOnly': value['isAdminOnly'],
        'showPromoCard': value['showPromoCard'],
        'numberOfEntrants': value['numberOfEntrants'],
        'termsUrl': value['termsUrl'],
        'termsContent': value['termsContent'],
        'onboardingSection': ChallengeOnboardingToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(ChallengeFaqDetailsToJSON)),
        'eligibilityCheckboxes': value['eligibilityCheckboxes'] == null ? undefined : ((value['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxToJSON)),
        'eligibilityGeo': ChallengeEligibilityGeoToJSON(value['eligibilityGeo']),
        'eligibilityConfig': EligibilityConfigToJSON(value['eligibilityConfig']),
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ChallengeSegmentToJSON)),
        'draws': value['draws'] == null ? undefined : ((value['draws'] as Array<any>).map(ChallengeDrawToJSON)),
        'prizePoolFeatureImage': value['prizePoolFeatureImage'],
        'titleFontSize': value['titleFontSize'],
        'brandMapSlug': value['brandMapSlug'],
        'brandLogoUrl': value['brandLogoUrl'],
        'backgroundImageLargeUrl': value['backgroundImageLargeUrl'],
        'backgroundImageSmallUrl': value['backgroundImageSmallUrl'],
        'prizePoolFeatureImageUrl': value['prizePoolFeatureImageUrl'],
        'challengeType': ChallengeTypeToJSON(value['challengeType']),
        'pageMode': ChallengePageModeToJSON(value['pageMode']),
        'slug': value['slug'],
        'landingPageUrl': value['landingPageUrl'],
        'requiresDevourPlay': value['requiresDevourPlay'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'videoSection': ChallengeVideoSectionToJSON(value['videoSection']),
        'contentSections': value['contentSections'] == null ? undefined : ((value['contentSections'] as Array<any>).map(ChallengeContentSectionToJSON)),
        'seo': PageSeoToJSON(value['seo']),
        'defaultAvatarImageId': value['defaultAvatarImageId'],
        'defaultAvatarImageUrl': value['defaultAvatarImageUrl'],
        'emailConfig': ChallengeEmailConfigToJSON(value['emailConfig']),
        'notificationWebhookUrl': value['notificationWebhookUrl'],
        'brandId': value['brandId'],
        'brandActivationId': value['brandActivationId'],
        'brandName': value['brandName'],
        'start': value['start'],
        'end': value['end'],
        'grandPrize': ChallengeGrandPrizeToJSON(value['grandPrize']),
        'communityGoal': ChallengeCommunityGoalResponseToJSON(value['communityGoal']),
        'promotionsSection': ChallengePromotionsSectionConfigToJSON(value['promotionsSection']),
        'faqLeftContent': value['faqLeftContent'],
        'faqStyles': ChallengeSectionStyleConfigToJSON(value['faqStyles']),
        'onboardingStyles': ChallengeSectionStyleConfigToJSON(value['onboardingStyles']),
        'prizeSectionStyles': ChallengeSectionStyleConfigToJSON(value['prizeSectionStyles']),
        'entriesColumnStyles': ChallengeSectionStyleConfigToJSON(value['entriesColumnStyles']),
        'questsStyles': ChallengeSectionStyleConfigToJSON(value['questsStyles']),
        'customHeadHtml': value['customHeadHtml'],
        'customBodyHtml': value['customBodyHtml'],
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'gamificationModelId': value['gamificationModelId'],
        'referralCodePrefix': value['referralCodePrefix'],
        'referralBonus': ChallengeReferralBonusToJSON(value['referralBonus']),
        'allowedSignupMethods': value['allowedSignupMethods'] == null ? undefined : ((value['allowedSignupMethods'] as Array<any>).map(SignupMethodToJSON)),
        'wheelMilestoneThresholds': value['wheelMilestoneThresholds'],
        'isAccepted': value['isAccepted'],
        'onboardingComplete': value['onboardingComplete'],
        'myStatus': value['myStatus'],
        'myDeclaredCountry': value['myDeclaredCountry'],
        'myMembershipNeedsCompletion': value['myMembershipNeedsCompletion'],
        'myAttestationOnFile': value['myAttestationOnFile'],
        'instantReward': ChallengeInstantRewardToJSON(value['instantReward']),
        'games': value['games'] == null ? undefined : ((value['games'] as Array<any>).map(OWGameResponseToJSON)),
    };
}

